let count = 0;
export function genInputId() {
  return count++;
}

export function resetInputId() {
  count = 0;
}
